import { render, staticRenderFns } from "./BlockConfig.vue?vue&type=template&id=4f0b7dc3&"
import script from "./BlockConfig.vue?vue&type=script&lang=js&"
export * from "./BlockConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports